import { Typography } from "antd";
import React from "react";

function Commonformerror({
  required,
  touched,
  error,
  name,
}: {
  required: boolean;
  touched: any;
  error: any;
  name: any;
}) {
  return (
    <>
      {required && touched?.[name] && error?.[name] && (
        <Typography className="required_text">{error?.[name]}</Typography>
      )}
    </>
  );
}

export default Commonformerror;
